import { Component } from '@angular/core';

@Component({
  selector: 'app-b2b-contracts-dashboard',
  templateUrl: './b2b-contracts-dashboard.component.html',
  styleUrls: ['./b2b-contracts-dashboard.component.css']
})
export class B2bContractsDashboardComponent {}
